let ticks=5;
const addInfoElement = async () => {
    try {
      // Prvo dodajemo CSS stilove
      const styleElement = document.createElement('style');
      styleElement.textContent = `
        .info {
          width: 18px;
          height: 18px;
          display: flex;
          cursor: pointer;
          margin: 0 auto 0 10px;
        }
      `;
      document.head.appendChild(styleElement);
  
      // Pronalazimo container element
      const container = document.querySelector('.collection-grid__facets');
      if (!container) {
        throw new Error('Container element not found');
      }
  
      // Pronalazimo sve font-accordion elemente
      const accordions = container.querySelectorAll('.font-accordion');
      
      // Tražimo element koji sadrži tekst "Size"
      const sizeAccordion = Array.from(accordions).find(accordion => 
        accordion.textContent.trim() === 'Size'
      );
  
      if (!sizeAccordion) {
        throw new Error('Size accordion not found');
      }
  
      // Proveravamo da li info element već postoji
      const existingInfo = sizeAccordion.nextElementSibling?.classList.contains('info');
      if (existingInfo) {
        console.log('Info element already exists');
        return;
      }
  
      // Kreiramo novi info element sa SVG ikonom
      const infoElement = document.createElement('div');
      infoElement.className = 'info';
      
      // Dodajemo SVG sadržaj
      infoElement.innerHTML = `
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 18C10.78 18 12.5201 17.4722 14.0001 16.4832C15.4802 15.4943 16.6337 14.0887 17.3149 12.4442C17.9961 10.7996 18.1743 8.99002 17.8271 7.24419C17.4798 5.49836 16.6226 3.89471 15.364 2.63604C14.1053 1.37737 12.5016 0.520203 10.7558 0.172936C9.00998 -0.17433 7.20038 0.00389957 5.55585 0.685088C3.91131 1.36628 2.50571 2.51983 1.51677 3.99987C0.527841 5.47991 0 7.21997 0 9C0.00268753 11.3861 0.951762 13.6737 2.63901 15.361C4.32625 17.0482 6.61388 17.9973 9 18ZM9 2C10.3845 2 11.7378 2.41055 12.889 3.17972C14.0401 3.94889 14.9373 5.04214 15.4672 6.32122C15.997 7.6003 16.1356 9.00777 15.8655 10.3656C15.5954 11.7235 14.9287 12.9708 13.9497 13.9497C12.9708 14.9287 11.7235 15.5954 10.3656 15.8655C9.00776 16.1356 7.6003 15.997 6.32122 15.4672C5.04213 14.9373 3.94888 14.0401 3.17971 12.889C2.41054 11.7378 2 10.3845 2 9C2.00211 7.14413 2.74029 5.36489 4.05259 4.05259C5.36488 2.74029 7.14413 2.00212 9 2ZM10 14H8V7.4H10V14ZM8 5.00001C8 4.80223 8.05865 4.60889 8.16853 4.44444C8.27841 4.28 8.43459 4.15182 8.61732 4.07614C8.80004 4.00045 9.00111 3.98064 9.19509 4.01923C9.38907 4.05782 9.56725 4.15306 9.7071 4.29291C9.84696 4.43276 9.9422 4.61094 9.98078 4.80492C10.0194 4.99891 9.99957 5.19997 9.92388 5.3827C9.84819 5.56542 9.72002 5.7216 9.55557 5.83148C9.39112 5.94137 9.19778 6.00001 9 6.00001C8.86868 6.00001 8.73864 5.97415 8.61732 5.92389C8.49599 5.87364 8.38575 5.79998 8.29289 5.70712C8.20003 5.61426 8.12637 5.50402 8.07612 5.3827C8.02586 5.26137 8 5.13134 8 5.00001Z" fill="#353535"/>
        </svg>
      `;
  
      // Dodajemo element nakon Size accordion-a
      sizeAccordion.insertAdjacentElement('afterend', infoElement);
      console.log('Info element successfully added');
  
    } catch (error) {
      console.error('Error:', error.message);
      // Čekamo 2 sekunde pre ponovnog pokušaja
     
      await new Promise(resolve => setTimeout(resolve, 2000));
      // Rekurzivno pozivamo funkciju
      if(ticks > 0){
        console.log(ticks)
      addInfoElement();
        ticks--;
      }
    }
  };
  
  // Pokrećemo funkciju
  addInfoElement();
  
  
  
  
  const initializeInfoBanner = () => {
    // Selektori za elemente
    const infoButtons = document.querySelectorAll('.info');
    const infoBanner = document.querySelector('.info-wrap');
    const overlay = document.querySelector('.overlay-info-wrap');
    const closeButton = document.querySelector('.info-close');
  
    // CSS stilovi za otvoreno stanje
    const openBannerStyles = {
      position: 'fixed',
      top: '0',
      right: 'auto',
      bottom: '0',
      left: '0',
      zIndex: '10000000000000',
      opacity: '1'
    };
  
    const openOverlayStyles = {
      position: 'fixed',
      top: '0',
      right: '0',
      bottom: '0',
      left: '0',
      background: 'rgb(0, 0, 0)',
      zIndex: '1000000000',
      opacity: '0.2'
    };
  
    const closedBannerStyles = {
      position: 'fixed',
      top: '0',
      right: 'auto',
      bottom: '0',
      left: '-500px',
      zIndex: '-1',
      opacity: '0'
    };
  
    const closedOverlayStyles = {
      position: 'fixed',
      top: '0',
      right: '0',
      bottom: '0',
      left: '0',
      background: 'rgba(0, 0, 0, 0.2)',
      width: '100%',
      height: '100%',
      zIndex: '-1',
      opacity: '0'
    };
  
    // Funkcija za primenu stilova
    const applyStyles = (element, styles) => {
      Object.assign(element.style, styles);
    };
  
    // Funkcija za otvaranje banera
    const openBanner = () => {
      applyStyles(infoBanner, openBannerStyles);
      applyStyles(overlay, openOverlayStyles);
    };
  
    // Funkcija za zatvaranje banera
    const closeBanner = () => {
      applyStyles(infoBanner, closedBannerStyles);
      applyStyles(overlay, closedOverlayStyles);
    };
  
    // Event handler za klik na info dugme
    const handleInfoClick = (e) => {
      e.stopPropagation(); // Sprečavamo propagaciju događaja
      openBanner();
    };
  
    // Event handler za klik na overlay
    const handleOverlayClick = (e) => {
      if (e.target === overlay) {
        closeBanner();
      }
    };
  
    // Event handler za klik na close dugme
    const handleCloseClick = (e) => {
      e.stopPropagation();
      closeBanner();
    };
  
    // Event handler za klik izvan banera
    const handleOutsideClick = (e) => {
      if (!infoBanner.contains(e.target) && !Array.from(infoButtons).some(btn => btn.contains(e.target))) {
        closeBanner();
      }
    };
  
    // Dodavanje event listenera za info dugmad
    infoButtons.forEach(button => {
      // Dodajemo listener na samo dugme
      button.addEventListener('click', handleInfoClick);
      
      // Dodajemo listener na sve child elemente
      button.querySelectorAll('*').forEach(child => {
        child.addEventListener('click', handleInfoClick);
      });
    });
  
    // Dodavanje event listenera za close dugme
    if (closeButton) {
      // Dodajemo listener na samo dugme
      closeButton.addEventListener('click', handleCloseClick);
      
      // Dodajemo listener na sve child elemente
      closeButton.querySelectorAll('*').forEach(child => {
        child.addEventListener('click', handleCloseClick);
      });
    }
  
    // Dodavanje event listenera za overlay
    overlay?.addEventListener('click', handleOverlayClick);
  
    // Dodavanje event listenera za klikove izvan banera
    document.addEventListener('click', handleOutsideClick);
  
    // Inicijalno postavljanje zatvorenog stanja
    closeBanner();
  };
  
  // Pokretanje inicijalizacije
  document.addEventListener('DOMContentLoaded', initializeInfoBanner);
  